//INFO for type use types util
//INFO for validation use validatorTypes util
//INFO for references type use referenceTypes util
//lucide-react is used for icons; only the icon name needs to be passed.
const { types, referenceTypes, uiTypes } = require("./utils/types");
const { validatorTypes } = require("./utils/validatorTypes");

const models = [
  {
    tableName: "contact",
    read: true,
    create: true,
    edit: true,
    delete: true,
    comments: true, //for enabiling comments on view and edit
    references: [],
    icon: "Database",
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "name",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "email",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "email",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "phone",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "company",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "interest",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "timeline",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "description",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT_AREA, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "type",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "what_are_you_building_or_fixing",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "current_state_of_the_system",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "release_cadence_preference",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          // added for ui
          type: uiTypes.DATE, //UI Types
          validation: [], //UI Validation
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          // added for ui
          type: uiTypes.TEXT, //UI Types
          validation: [], //UI Validation
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
  },

  {
    tableName: "blog",
    read: true,
    create: true,
    edit: true,
    delete: true,
    comments: true, //for enabiling comments on view and edit
    references: [
      {
        tableName: "blog_category",
        foreignKey: "category_id",
        primaryKey: "id",
        type: referenceTypes.MANY_TO_MANY,
        displayKey: "name",
      },
    ],
    icon: "Database",
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "category_id",
        type: types.STRING,
        allowNull: true,
        isArray: true,
        validation: [validatorTypes.array, validatorTypes.optional],
        ui: {
          type: uiTypes.DROPDOWN_MULTISELECT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "title",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "description",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "meta_title",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "meta_description",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "portrait_card_image",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.DOCUMENT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "portrait_card_image_alt_text",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "blogs_details_image",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.DOCUMENT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "blogs_details_image_alt_text",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_profile",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.IMAGE,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_profile_alt",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_designation",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_about",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "content_section",
        type: types.JSONB,
        allowNull: false,
        validation: [validatorTypes.json, validatorTypes.required],
        isArray: true,
        ui: {
          type: uiTypes.EDITOR,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "slug",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "date_of_published",
        type: types.DATE,
        validation: [validatorTypes.date, validatorTypes.optional],
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "number_of_images",
        type: types.INTEGER,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          type: uiTypes.NUMBER,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "time_of_the_video",
        type: types.DOUBLE,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          type: uiTypes.NUMBER,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "date_of_update",
        type: types.DATE,
        validation: [validatorTypes.date, validatorTypes.optional],
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "published",
        type: types.BOOLEAN,
        defaultValue: false,
        validation: [validatorTypes.boolean, validatorTypes.optional],
        ui: {
          type: uiTypes.CHECKBOX,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "status",
        type: types.ENUM,
        enumValues: ["draft", "submitted", "approved", "published"],
        defaultValue: "draft",
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.DROPDOWN,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
          menuTopPlacement: true,
        },
      },
      {
        name: "read_time",
        type: types.DOUBLE,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          type: uiTypes.NUMBER,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
  },

  {
    tableName: "blog_category",
    read: true,
    create: true,
    edit: true,
    delete: true,
    comments: true, //for enabiling comments on view and edit
    references: [],
    icon: "Database",
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "status",
        type: types.ENUM,
        enumValues: ["draft", "active", "inactive"],
        defaultValue: "draft",
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.DROPDOWN,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
    ],
  },

  {
    tableName: "case_study",
    read: true,
    create: true,
    edit: true,
    delete: true,
    comments: true, //for enabiling comments on view and edit
    references: [
      {
        tableName: "case_study_category",
        foreignKey: "category_id",
        primaryKey: "id",
        type: referenceTypes.MANY_TO_MANY,
        displayKey: "name",
      },
    ],
    icon: "Database",
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "category_id",
        type: types.ARRAY,
        allowNull: true,
        isArray: true,
        validation: [validatorTypes.array, validatorTypes.optional],
        ui: {
          type: uiTypes.DROPDOWN_MULTISELECT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "title",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "description",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "meta_title",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "meta_description",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "card_stats",
        type: types.JSON,
        allowNull: false,
        validation: [validatorTypes.json, validatorTypes.optional],
        ui: {
          type: uiTypes.JSON,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "details_stats",
        type: types.JSON,
        allowNull: false,
        validation: [validatorTypes.json, validatorTypes.optional],
        ui: {
          type: uiTypes.JSON,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "portrait_card_image",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.DOCUMENT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "portrait_card_image_alt_text",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "blogs_details_image",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.DOCUMENT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "blogs_details_image_alt_text",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_profile",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.IMAGE,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_profile_alt",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_designation",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "author_about",
        type: types.STRING,
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT_AREA,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "content_section",
        type: types.JSONB,
        allowNull: false,
        validation: [validatorTypes.json, validatorTypes.required],
        isArray: true,
        ui: {
          type: uiTypes.EDITOR,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "slug",
        type: types.STRING,
        allowNull: false,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "date_of_published",
        type: types.DATE,
        validation: [validatorTypes.date, validatorTypes.optional],
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "number_of_images",
        type: types.INTEGER,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          type: uiTypes.NUMBER,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "time_of_the_video",
        type: types.DOUBLE,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          type: uiTypes.NUMBER,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "date_of_update",
        type: types.DATE,
        validation: [validatorTypes.date, validatorTypes.optional],
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: false,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "published",
        type: types.BOOLEAN,
        defaultValue: false,
        validation: [validatorTypes.boolean, validatorTypes.optional],
        ui: {
          type: uiTypes.CHECKBOX,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "status",
        type: types.ENUM,
        enumValues: ["draft", "submitted", "approved", "published"],
        defaultValue: "draft",
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.DROPDOWN,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
          menuTopPlacement: true,
        },
      },
      {
        name: "read_time",
        type: types.DOUBLE,
        validation: [validatorTypes.number, validatorTypes.optional],
        ui: {
          type: uiTypes.NUMBER,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "createdAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "updatedAt",
        type: types.DATE,
        allowNull: false,
        defaultValue: null,
        ui: {
          type: uiTypes.DATE,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "deletedAt",
        type: types.DATE,
        allowNull: true,
        defaultValue: null,
        read: false,
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: false,
          read: false,
          create: false,
          edit: false,
        },
      },
    ],
  },

  {
    tableName: "case_study_category",
    read: true,
    create: true,
    edit: true,
    delete: true,
    comments: true, //for enabiling comments on view and edit
    references: [],
    icon: "Database",
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "name",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
      {
        name: "status",
        type: types.ENUM,
        enumValues: ["draft", "active", "inactive"],
        defaultValue: "draft",
        validation: [validatorTypes.string, validatorTypes.optional],
        ui: {
          type: uiTypes.DROPDOWN,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
    ],
  },

  {
    tableName: "newsletter",
    read: true,
    create: true,
    edit: true,
    delete: true,
    comments: true, //for enabiling comments on view and edit
    references: [],
    icon: "Database",
    columns: [
      {
        name: "id",
        type: types.UUID,
        allowNull: false,
        defaultValue: types.UUIDV4,
        primaryKey: true,
        validation: [validatorTypes.uuid, validatorTypes.optional],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: false,
          edit: false,
        },
      },
      {
        name: "email",
        type: types.STRING,
        allowNull: true,
        validation: [validatorTypes.string, validatorTypes.required],
        ui: {
          type: uiTypes.TEXT,
          validation: [],
          list: true,
          read: true,
          create: true,
          edit: true,
        },
      },
    ],
  },
];

module.exports = models;
